import type { ICard } from "../../cardsSlice";

export const major16Card: ICard = {
    id: "major_16",
    arcana: "major",
    number: 16,
    suit: "major",
    court: "major",
    name: "Башня",
    nameEn: "The Tower",
    keywords: ["Разрушение", "Освобождение", "Внезапные перемены"],
    symbolism: ["Башня, поражённая молнией", "Падающие люди", "Корона, пламя, ночное небо"],
    symbolismInterpretation:
      "Символ резкого слома устаревших структур и неожиданного освобождения",
    archetype: "Внезапное прозрение, разрушение иллюзий, архетип очищения",
    psychology: "Потрясение, освобождение от старых убеждений и эго",
    upright: {
      personality: "Кризис, катарсис, резкий сдвиг",
      relationships: "Неожиданный разрыв, обострение конфликта",
      work: "Потеря позиции, крушение планов",
      spirituality: "Слом эго, начало настоящего роста",
      examples: ["Слом старых паттернов", "Откровение", "Резкое пробуждение"]
    },
    reversed: {
      meaning: "Сопротивление переменам, затяжной кризис",
      nuances: "Отказ признать необходимость разрушения"
    },
    associations: ["Гром", "Падение", "Молния", "Очистка"],
    combinations: ["С Дьяволом — разрушение зависимостей", "Со Звездой — надежда после крушения"],
    readingTips: ["Понимать, что разрушение необходимо", "Видеть в нём освобождение"],
    selfQuestions: ["Что во мне требует изменений?", "Какие структуры пора отпустить?"]
  };


